import { Injectable } from '@angular/core'
import { ShopBankOfferDto, ShopConfigDto, StripeCheckoutDto } from '@mos/api/bank/dto-client'
import { Observable } from 'rxjs'
import { BankService } from './bank.service'

@Injectable({ providedIn: 'root' })
export class WebBankService extends BankService {
	getOffers(): Observable<ShopConfigDto> {
		return this.getApiOffers()
	}
	consumeOffer(offer: ShopBankOfferDto): Observable<StripeCheckoutDto> {
		return this.http.post<StripeCheckoutDto>(`@api/bank/consume/offer/${offer.id}`, {})
	}
}
